import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import GenericTable from './UI/reusable-components/GenericTable';
import Product from './UI/reusable-components/Product';
import { fetchProducts } from '../redux/actions/productAction';
import productService from '../services/productService';
import categoryService from '../services/categoryService';
import { getMarketPlaces } from '../redux/actions/marketplacesActions';
import { getEcommercePlaces } from '../redux/actions/ecommercePlaceActions';
import axios from 'axios';
import { Button, Dialog, DialogTitle, DialogContent, DialogActions, Typography, CircularProgress, MenuItem } from '@mui/material';
import { DeleteOutline } from '@mui/icons-material';
import useAlert from '../hooks/useAlert';
import Swal from 'sweetalert2';

const productStates = [
  {
    value: 1,
    label: "Durum 1"
  },
  {
    value: 2,
    label: "Durum 2"  
  },
  {
    value: 3,
    label: "Durum 3"
  },
]
export const Products = ({ setModel, model }) => {
  const dispatch = useDispatch();


  const [currentPage, setCurrentPage] = useState(1);


  const [pageSize, setPageSize] = useState(10);



  const [filtersValue, setFiltersValue] = useState(null);
  const authUserId = useSelector(state => state?.auth?.user?.id);
  const token = useSelector((state) => state?.auth?.user?.accessToken?.token);
  const [comboBoxFilter, setComboBoxFilter] = useState(null)
  const { products, filters, loading, error, totalProducts } = useSelector((state) => state.products);
  const [productsx, setProductsx] = React.useState([]);
  const [totalProductsx, setTotalProductsx] = React.useState([]);

  const [suppliers, setSuppliers] = React.useState([]);
  const [categories, setCategories] = React.useState([]);
  const [marketpleaces, setMarketpleaces] = React.useState([]);
  const [ecommerces, setEcommerces] = React.useState([]);

  const [isLoading, setIsLoading] = useState(false);
  const [selectedData, setSelectedData] = useState([]);
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
  const [isDeleting, setIsDeleting] = useState(false);
  const { showSuccessAlertDeleteProduct, showErrorAlertAll } = useAlert();

  const headers = ['Başlık', 'Fiyat Listesi', 'Stok', 'Kategori', 'Platform Yükleme Durumları', 'İşlemler'];
  const API_MARKETPLACES_URL = import.meta.env.VITE_API_URL;
  const [filterFields, setFilterFields] = useState([
    { label: "Ürün Adı", name: "title", type: "text", value: null },
    { label: "Ürün Barcode", name: "barcode", type: "text", value: null },
  ]);

  const comboBoxFilterFields = [
    { label: "Tedarikçiler", name: "SuplierId", options: suppliers },
    { label: "Kategori", name: "categoryId", options: categories },
    { label: "Pazaryeri Platformları", name: "transferMarketPlaceId", options: marketpleaces },
    { label: "Eticaret Platformları", name: "transferEcommercePlaceId", options: ecommerces },
  ];

  const rangeInputFilterFields = [];

  const fieldsToClear = {
    title: '',
    barcode: '',
    supplier: '',
    category: '',
    status: '',
  };

  const handleOnSearchFilters = async (filters) => {
    const model = comboBoxFilter != null ? comboBoxFilter : filters;
    setModel(model);
    setCurrentPage(1);
  }


  const fetchData = async (model) => {
    setIsLoading(true) 
    const response = await axios.get(`${API_MARKETPLACES_URL}/Product`, {
      params: {
        UserId: authUserId,
        Page: currentPage,
        PageSize: pageSize,
        WithCategory: true,
        WithProductAttribute: false,
        WithProductPlaces: true,
        WithBrand: false,
        WithProductBarcodes: true,
        WithProductImages: true,
        WithProductPriceHistories: false,
        WithProductPrices: false,
        WithProductStockHistories: false,
        WithPurchasePrices: false,
        ...model,
      },
      headers: {
        Authorization: `Bearer ${token}`,
      },
    });
    setTotalProductsx(response.data.data.recordsTotal)
    setProductsx(response.data.data.data)

    setIsLoading(false)

  }

  useEffect(() => {
    handleOnSearchFilters({})
  }, []);


  useEffect(() => {
    const fetchFilterOptions = async () => {
      try {
        // Tedarikçileri yükle

        const providerResponse = await productService.fetchProviders();
        const supplierOptions = providerResponse.map((provider) => ({
          value: provider.id,
          label: provider.name,
        }));

        setSuppliers(supplierOptions);

        // Kategorileri yükle
        const categoryResponse = await categoryService.getCategoriesApiForDropdown(null, 1, null, authUserId);
        const categoryOptions = categoryResponse.data.data.data.map((category) => ({
          value: category.id,
          label: category.name,
        }));

        setCategories(categoryOptions);



        // marketyerlerini yükle
        const markeresponse = await dispatch(getMarketPlaces(token));
        if (markeresponse.success) {
          const data = markeresponse?.data.map((x) => ({
            value: x.id,
            label: x.name,
          }));
          setMarketpleaces(data);
        }

        const ecommerceResponse = await dispatch(getEcommercePlaces(token));
        if (ecommerceResponse.success) {
          const data = ecommerceResponse?.data.map((x) => ({
            value: x.id,
            label: x.name,
          }));
          setEcommerces(data);
        }
      } catch (error) {
        console.error("Filtre seçenekleri yüklenirken hata oluştu:", error);
      }
    };

    fetchFilterOptions(); // Tedarikçi ve kategori bilgilerini yükle
  }, []);

  const handlePageChange = (newPage) => {
    const maxPage = Math.ceil(totalProductsx / pageSize);
    if (newPage >= 1 && newPage <= maxPage) {
      setCurrentPage(newPage);
    }
  };

  useEffect(() => { 
    if (currentPage) {
      const model = comboBoxFilter != null ? comboBoxFilter : filters;
      fetchData(model || {});
    }
  }, [currentPage, model,pageSize]);

  const handleBulkDelete = () => {
    if (selectedData.length === 0) {
      return;
    }
    setDeleteConfirmOpen(true);
  };

  const handleConfirmDelete = async () => {
    if (selectedData.length === 0) {
      setDeleteConfirmOpen(false);
      return;
    }

    setIsDeleting(true);
    try {
      const ids = selectedData.map(item => item.id);
      await productService.deleteProductRange(ids);
      showSuccessAlertDeleteProduct();
      setSelectedData([]);
      setDeleteConfirmOpen(false);
      // Veriyi yeniden yükle
      const model = comboBoxFilter != null ? comboBoxFilter : filters;
      await fetchData(model || {});
    } catch (error) {
      setDeleteConfirmOpen(false);
      const errorMessage = error?.response?.data?.message || error?.message || "Ürünler silinirken bir hata oluştu. Lütfen tekrar deneyiniz.";
      Swal.fire({
        title: 'Hata Oluştu',
        text: errorMessage,
        icon: 'error',
        confirmButtonText: 'Tamam',
        confirmButtonColor: '#1565C0',
        customClass: {
          popup: 'swal-popup',
        },
        buttonsStyling: true,
        background: '#FFFFFF',
        color: '#424242',
      });
      console.error("Toplu silme hatası:", error);
    } finally {
      setIsDeleting(false);
    }
  };

  const handleCancelDelete = () => {
    setDeleteConfirmOpen(false);
  };

  if (error) {
    return <div>Hata: {error}</div>;
  }

  const bulkActionMenu = (
    <MenuItem
      onClick={handleBulkDelete}
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        color: "#1565C0",
        fontWeight: 500,
        "&:hover": {
          backgroundColor: "#E3F2FD",
          color: "#0D47A1",
        },
      }}
    >
      <DeleteOutline fontSize="small" />
      <span>Toplu Sil ({selectedData.length})</span>
    </MenuItem>
  );
  return (
    <>
      <GenericTable
        data={productsx}
        headers={headers}
        filterFields={filterFields}
        setFilterFields={setFilterFields}
        filterLogic={(product, filters) => true}
        RowComponent={Product}
        filters={filters}
        comboBoxFilterFields={comboBoxFilterFields}
        fieldsToClear={fieldsToClear}
        rangeInputFilterFields={rangeInputFilterFields}
        setFiltersValue={setFiltersValue}
        onSearchFilters={handleOnSearchFilters}
        setComboBoxFilter={setComboBoxFilter}
        comboBoxFilter={comboBoxFilter}
        currentPage={currentPage}
        setCurrentPage={handlePageChange}
        pageSize={pageSize}
        setPageSize={setPageSize}
        totalItems={Number(totalProductsx) || 0}
        isLoading={isLoading || loading}
        selectedData={selectedData}
        setSelectedData={setSelectedData}
        bulkActionMenu={bulkActionMenu}
      />

      {/* Toplu Silme Onay Dialog'u */}
      <Dialog
        open={deleteConfirmOpen}
        onClose={handleCancelDelete}
        maxWidth="xs"
        fullWidth
        PaperProps={{
          sx: {
            borderRadius: 3,
            boxShadow: "0 8px 32px rgba(13, 71, 161, 0.15)",
            border: "1px solid #E3F2FD",
          },
        }}
      >
        <DialogTitle 
          sx={{ 
            fontSize: { xs: "1.25rem", sm: "1.5rem" },
            color: "#0D47A1",
            fontWeight: 600,
            backgroundColor: "#E3F2FD",
            padding: "20px 24px",
            borderBottom: "1px solid #BBDEFB",
          }}
        >
          Toplu Silme Onayı
        </DialogTitle>
        <DialogContent sx={{ padding: "24px", backgroundColor: "#FAFAFA" }}>
          <Typography sx={{ fontSize: { xs: "0.875rem", sm: "1rem" }, color: "#424242", lineHeight: 1.6 }}>
            Seçili <strong style={{ color: "#1565C0" }}>{selectedData.length}</strong> ürünü silmek istediğinizden emin misiniz?
            <br />
            <strong style={{ color: "#0D47A1" }}>Bu işlem geri alınamaz!</strong>
          </Typography>
        </DialogContent>
        <DialogActions sx={{ p: { xs: 2, sm: 3 }, backgroundColor: "#F5F5F5", borderTop: "1px solid #E0E0E0" }}>
          <Button
            onClick={handleCancelDelete}
            disabled={isDeleting}
            fullWidth={false}
            variant="outlined"
            sx={{ 
              mb: { xs: 1, sm: 0 },
              color: "#1565C0",
              borderColor: "#90CAF9",
              borderRadius: "10px",
              "&:hover": {
                borderColor: "#1565C0",
                backgroundColor: "#E3F2FD",
              },
            }}
          >
            İptal
          </Button>
          <Button
            onClick={handleConfirmDelete}
            variant="contained"
            disabled={isDeleting}
            startIcon={isDeleting ? <CircularProgress size={20} color="inherit" /> : <DeleteOutline />}
            fullWidth={false}
            sx={{
              backgroundColor: "#1565C0",
              color: "#FFFFFF",
              borderRadius: "10px",
              "&:hover": {
                backgroundColor: "#0D47A1",
              },
              "&:disabled": {
                backgroundColor: "#90CAF9",
              },
            }}
          >
            {isDeleting ? "Siliniyor..." : "Evet, Sil"}
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};
